import { render, staticRenderFns } from "./RequestLetterSodorEsterdad.vue?vue&type=template&id=e20405e8&scoped=true&"
import script from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
export * from "./RequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
import style0 from "./RequestLetterSodorEsterdad.vue?vue&type=style&index=0&id=e20405e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e20405e8",
  null
  
)

export default component.exports